import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static values = { text: String };
  static targets = ["button"];

  async copy() {
    const text = this.textValue || this.element.dataset.clipboardText || "";
    if (!text) return;

    try {
      await navigator.clipboard.writeText(text);
      this.showCopied();
    } catch (err) {
      console.warn("Clipboard copy failed:", err);
      this.showError();
    }
  }

  showCopied() {
    const btn = this.hasButtonTarget ? this.buttonTarget : this.element;
    const originalText = btn.textContent;
    btn.textContent = "Copied!";
    btn.disabled = true;
    setTimeout(() => {
      btn.textContent = originalText;
      btn.disabled = false;
    }, 1500);
  }

  showError() {
    const btn = this.hasButtonTarget ? this.buttonTarget : this.element;
    const originalText = btn.textContent;
    btn.textContent = "Failed";
    setTimeout(() => {
      btn.textContent = originalText;
    }, 1500);
  }
}
